import { Component, OnInit, Input, OnDestroy, ViewEncapsulation, AfterViewChecked } from '@angular/core';
import { DataService } from '../../shared-service/data.service';
import { BaseService } from '../../shared-service/base.service';
import { DynamicFieldService } from './dynamic-field.service';

declare var $: any;

/*
How to Use this component
=================================
In .html File
//Pass values to inputs as follows
<app-dynamic-field [Mode]="'Edit'" Module="AN" [ItemId]="1" [HeaderText]="'Dynamic Fields'" [ValidationHighlightWithMessage]="false"
[DynmcQueryPlaceholdersJson]="{'@NM_CRPRT_ID':'1','@NM_USR_ID':'1'}" 
[FieldVisibilityPermissions]="[{'FieldId':1, 'CanEdit':true, 'IsMandatory':true},{'FieldId':2, 'CanEdit':true, 'IsMandatory':true}]"></app-dynamic-field>

In .ts File
=============
//Add DynamicFieldComponent as ViewChild as below:
@ViewChild(DynamicFieldComponent) dynamicFieldComp: DynamicFieldComponent;

Call GetDynamicFieldData() //to get Dynamic fields data
Call DisplayValidation() //to display validations if validation fails
*/


@Component({
  selector: 'app-dynamic-field',
  templateUrl: './dynamic-field.component.html',
  styleUrls: ['./dynamic-field.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DynamicFieldComponent implements OnInit {
  constructor(private dataService: DataService, public bs: BaseService, private dyns: DynamicFieldService) {

  }
  //Possible Mode input = "Add" / "Edit" / "View"
  @Input() Mode: any = "";
  //Module Code like "AN", "UM"
  @Input() Module: any = "";
  @Input() ItemId: any = "";
  @Input() HeaderText: any = "";
  //true if want to highlight field with validation message display else false to only highlight field
  @Input() ValidationHighlightWithMessage: boolean = false;
  /*
  Json string for Dynamic query placeholder key,value pair like 
    {'@NM_CRPRT_ID':'1','@NM_USR_ID':'1'}
  */
  @Input() DynmcQueryPlaceholdersJson: any = "";
  /*Json Array object for Field visiblity and editable permissions like 
    [
      {'FieldId':3, 'CanAdminEdit':true, 'CanUserEdit':true, 'IsMandatory':false},
      {'FieldId':6, 'CanAdminEdit':true, 'CanUserEdit':true, 'IsMandatory':true}
    ]
  */
  @Input() FieldVisibilityPermissions: Object = [];

  //Characters to be allowed in numeric field, Passed the KeyCode in array
  protected specialKeys: Array<number> = [8];
  protected params: Object = {};
  public DynamicFieldsData: Array<{
    DynFieldValueType:any,
    DynFieldName:any,
    IsMandatory:any,
    EncodedFieldControlId:any,
    DynFieldId:any,
    IsPopulateFromDataSource:any,
    FieldSpecificData:Array<any>,
    FieldAutoPopulateData:Array<any>,
    DisplayText:any,
    MultiSelectItems:any,
    MultiSelectItemsSelected:any,
    IsAutoPopulate:any,
    DynFieldMaxLength:any,
    IsImageType:any,
    FileName:any,
    FilePath:any,
    DynFieldTextBoxValueType:any,
    DynFieldTextBoxRegexExpression:any,
  }> = [];
  protected isCalendarInitialized: boolean = false;
  protected colorArray: any[] = ['red', 'blue', 'black', 'yellow', 'green'];

  public editorConfig = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'direction': 'rtl' }],                         // text direction
      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [
        { 'color': this.colorArray.slice() },
        { 'background': this.colorArray.slice() }
      ],   // dropdown with defaults from theme
    ]
  };

  protected MultiSelectItems: Array<Object> = [];
  protected MultiSelectItemsSelected: Array<Object> = [];

  ngOnInit() {
    this.getDynamicFieldDetailFromServer();
    this.FieldVisibilityPermissions
  }

  protected getDynamicFieldDetailFromServer() {
    this.params = {
      Module: this.Module,
      ItemId: this.ItemId,
      Mode: this.Mode.toLowerCase(),
      DynmcQueryPlaceholdersJson: JSON.stringify(this.DynmcQueryPlaceholdersJson),
      FieldVisibilityPermissions: this.FieldVisibilityPermissions
    };

    this.dyns.getEntityDynamicFieldFromServer(this.params, "****").then((data: Array<Object>|any) => {

      if (Object.keys(data).length > 0) {
        this.DynamicFieldsData = data;

      }
    }, (data) => {
      this.bs.log('error', 'Error in getting dynamic fields');
    });
  }

  ngAfterViewChecked() {
    this.SetCalander();
  }

  SetCalander() {
    if (this.DynamicFieldsData != undefined && Object.keys(this.DynamicFieldsData).length > 0 && this.isCalendarInitialized == false) {
      this.isCalendarInitialized = true;
      var x = this.bs.getUserAttr("GlobalDateFormat");
      var startYear = this.bs.getUserAttr("YearStartValue");
      x = x.replace("MM", "mm");
      x = x.replace("yyyy", "yy");
      $(".Dycalander").each(function () {
        var DtId = '#' + this.id;
        if ($(DtId).attr('can-edit').toLowerCase() != 'false') {
          $(DtId).datepicker({
            dateFormat: x,
            date: function () { return new Date(1434544649384); },
            altField: DtId,

            inline: true,
            changeYear: true,
            yearRange: startYear + ':' + (new Date().getFullYear() + 40),
            onSelect: function () {
              var day1 = $(DtId).datepicker('getDate').getDate();
              var month1 = $(DtId).datepicker('getDate').getMonth() + 1;
              var year1 = $(DtId).datepicker('getDate').getFullYear();
              var fullDate = year1 + "/" + month1 + "/" + day1;
              $(DtId).innerText = fullDate;
              $('#' + this.id + '_Error').html('');
              $('#' + this.id + '_Error').hide();
              $("#" + this.id).removeClass("errorBox");
            }
          });
        }
      });
    }
  }


  editorContentChanged(ev: Event|any, dynField:any) {

    $("#" + dynField["EncodedFieldControlId"] + "Value_hdnfld").val(ev["html"]);
    this.ClearError(dynField["EncodedFieldControlId"]);
    // this.validateText(ev['editor']['root']['innerText'], ev['editor']['root']['innerHTML'], id);
  }

  IsFieldEditable(dynField:any): boolean {
    let IsEditableField: boolean;
    IsEditableField = ((dynField["IsAutoPopulate"] == true && dynField["IsMandatory"] == true)
      && (this.Mode.toLowerCase() == "edit" || this.Mode.toLowerCase() == "add"))
      || ((dynField['CanEdit'] && this.Mode.toLowerCase() == "edit") || (dynField['CanEdit'] && this.Mode.toLowerCase() == "add"));
    return IsEditableField
  }

  openFile(dynField:any) {
    window.open(dynField["FilePath"]);
  }

  IsNumeric(e:any) {
    var keyCode = e.which ? e.which : e.keyCode
    var ret = ((keyCode >= 48 && keyCode <= 57) || this.specialKeys.indexOf(keyCode) != -1);
    return ret;
  }


  GetDynamicFieldData(): string {

    let fieldIds = $('[name="FieldValueArray_hdnfld"]');

    let FieldIDValuePairArray:any = [];
    fieldIds.each(function (idx:any, hdnfld:any) {
      let Id = $(hdnfld).attr("id").replace("_hdnfld", "");

      let permissions = JSON.parse($('[id="' + Id + 'Permission_hdnfld"]').val());
      
      let datafld;
      datafld = $('[id="' + Id + '"]');
      if (datafld == undefined || (datafld != undefined && datafld.length == 0))
        datafld = $('[id$="' + Id + '"]');

      let value;
      let eleType = $('[id$="' + Id + '"]').not("[type='hidden']").prop("type");
      if (eleType == undefined) {
        eleType = $('[id$="' + Id + '"]').not("[type='hidden']").prop("tagName");
      }

      switch (eleType) {
        case 'checkbox':
          value = $(datafld).first().is(":checked")
          break;
        case 'APP-FILE-UPLOAD':
          let pathvalue = $('[id^="encryptedFilePath"]').filter('[id$="' + Id + '"]').first().val();
          if (pathvalue == undefined || (pathvalue != undefined && pathvalue.length == 0)) {
            pathvalue = $('[id="' + Id + 'ImagePath_hdnfld"]').val();
          }

          let removevalue = false;
          let PathJson = { FilePath: pathvalue, IsRemoved: removevalue };
          value = JSON.stringify(PathJson);
          break;
        case "QUILL-EDITOR":
          value = $('[id="' + Id + 'Value_hdnfld"]').val();
          break;
        case "ANGULAR2-MULTISELECT":
          value = "[" + $('[id="' + Id + 'Value_hdnfld"]').val() + "]";
          break;
        default:
          value = $(datafld).first().val();
          break;
      }

      let FieldIdValuePair = {
        FieldId: parseInt($(hdnfld).val()),
        FieldValue: value,
        IsMandatory: permissions.IsMandatory,
        CanEdit: permissions.CanEdit
      };
      FieldIDValuePairArray.push(FieldIdValuePair);
    });



    return JSON.stringify(FieldIDValuePairArray);
  }

  onItemSelect(item: any, dynField:any) {
    let currValue = $("#" + dynField["EncodedFieldControlId"] + "Value_hdnfld").val();
    let selectedArr: Array<string> = [];
    if (currValue && currValue.length > 0)
      selectedArr = currValue.split(',');
    selectedArr.push('"' + item.id + '"');
    let newSelected = selectedArr.join(',');
    $("#" + dynField["EncodedFieldControlId"] + "Value_hdnfld").val(newSelected);
    this.ClearError(dynField["EncodedFieldControlId"]);
  }

  OnItemDeSelect(item: any, dynField:any) {
    let currValue = $("#" + dynField["EncodedFieldControlId"] + "Value_hdnfld").val();
    let selectedArr: Array<string> = [];
    selectedArr = currValue.split(',');
    for (var i = 0; i < selectedArr.length; i++) {
      if (selectedArr[i] == '"' + item.id + '"') {
        selectedArr.splice(i, 1);
        break;
      }
    }
    let newSelected = selectedArr.join(',');
    $("#" + dynField["EncodedFieldControlId"] + "Value_hdnfld").val(newSelected);
  }

  onSelectAll(items: any, dynField:any) {
    $("#" + dynField["EncodedFieldControlId"] + "Value_hdnfld").val('')
    let selectedArr: Array<string> = [];
    for (var i = 0; i < items.length; i++) {
      selectedArr.push('"' + items[i].id + '"');
    }
    let newSelected = selectedArr.join(',');
    $("#" + dynField["EncodedFieldControlId"] + "Value_hdnfld").val(newSelected);
    this.ClearError(dynField["EncodedFieldControlId"]);
  }

  onDeSelectAll(items: any, dynField:any) {
    $("#" + dynField["EncodedFieldControlId"] + "Value_hdnfld").val('');
  }


  DisplayValidation(validations:any) {
    let ValidationsArray: Array<Object>;
    ValidationsArray = validations;
    ValidationsArray.forEach((val:any) => {
      $("#" + val["Name"]).addClass("errorBox");
      $("#" + val["Name"] + " .c-btn").addClass("errorBox");
      $("#" + val["Name"] + " .bootstrap-filestyle").addClass("errorBox");
      $("#" + val["Name"] + " .ql-container").addClass("errorBox");
      if (this.ValidationHighlightWithMessage == true) {
        $("#" + val["Name"] + "_Error").html(val["Error"]);
        $("#" + val["Name"] + "_Error").show();
      }
    });
  }

  ClearError(id:any) {
    $('#' + id + '_Error').html('');
    $('#' + id + '_Error').hide();
    $("#" + id).removeClass("errorBox");
    $("#" + id + " .c-btn").removeClass("errorBox");
    $("#" + id + " .bootstrap-filestyle").removeClass("errorBox");
    $("#" + id + " .ql-container").removeClass("errorBox");
  }
}
